import { z } from 'zod';
import { type RespondedType, responseScheme } from '@/models/response';
import { friendScheme } from '@/models/user/friend';
import { userInfoSchema } from '@/models/user/user-info';
import { avatarUrlSchema } from '@/utils/schemas';
import { genderSchema } from './common';

export const sameGroupSchema = z.object({
  AddFriend: z.number(),
  AllBan: z.number(),
  AutoDeleteTime: z.number(),
  CreateTime: z.string(),
  CreatorHeadImg: avatarUrlSchema,
  CreatorID: z.number(),
  CreatorName: z.string(),
  GroupCode: z.number(),
  GroupImg: avatarUrlSchema,
  GroupName: z.string(),
  ID: z.number(),
  Info: z.string(),
  JoinType: z.number(),
  LastMsg: z.string(),
  LastMsgTimeStamp: z.number(),
  MaxUserCount: z.number(),
  ReadDelete: z.number(),
  UserCount: z.number(),
});

export type SameGroup = z.infer<typeof sameGroupSchema>;

export const friendInfoScheme = z
  .object({
    FriendNickName: z.string(),
    FriendHeadImg: avatarUrlSchema,
    FriendSign: z.string(),
    FriendGender: genderSchema,
  })
  .merge(
    friendScheme.pick({
      ID: true,
      UserID: true,
      FriendID: true,
      RemarkName: true,
      IsOnline: true,
      Hide: true,
      Shield: true,
      Status: true,
      CreateTime: true,
      SortChar: true,
    }),
  );

export type FriendInfo = z.infer<typeof friendInfoScheme>;

export const friendInfoResponseScheme = z
  .object({
    IsFriend: z.number().pipe(z.coerce.boolean()).nullish().default(0),
    UserInfo: userInfoSchema.omit({ TelCode: true, Phone: true }).nullish(),
    FriendInfo: friendInfoScheme.nullish(),
    CommonGroup: z.array(sameGroupSchema).nullish(),
  })
  .merge(responseScheme);

export type FriendInfoResponseType = z.infer<typeof friendInfoResponseScheme> & RespondedType;
